export enum TRANSACTION {
  UNKNOWN = 0,
  SHOWN_URL = 1,
  WAITING_FOR_CHARGE = 2,
  CHARGED = 3,
  REFUNDED = 4,
  ERROR_GENERAL = 90000,
  ERROR_INVALID_PHONE = 90001,
}
